import React from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

// Components
import AlertTemplate from "~/common/components/AlertPortal/AlertTemplate";
import Form from "~/common/components/Form";
import Input from "~/common/components/Input";

const JoinForm = ({
	registerForm,
	setCurrentStep,
	request,
	validateModal,
	setValidateModal,
	validateModalType,
	validateModalMsg,
}) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const currentPassword = registerForm.watch("pw");

	return (
		<>
			<Form useForm={registerForm} className="register-form vertical">
				<Input
					label={t("pages.auth.JoinPage.Contents.JoinForm.name")}
					placeholder={t("pages.auth.JoinPage.Contents.JoinForm.name")}
					name="name"
					autoComplete="new-password"
					required
				/>

				<Input
					label={t("pages.auth.JoinPage.Contents.JoinForm.email")}
					placeholder={t("pages.auth.JoinPage.Contents.JoinForm.email")}
					name="id_email"
					type="email"
					autoComplete="new-password"
					required
				/>

				<Input
					label={t("pages.auth.JoinPage.Contents.JoinForm.pw")}
					placeholder={t("pages.auth.JoinPage.Contents.JoinForm.useSpecial")}
					name="pw"
					type="password"
					autoComplete="new-password"
					validation={{
						pattern: {
							value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+]).{8,16}$/,
							message: t("pages.auth.JoinPage.Contents.JoinForm.useSpecial"),
						},
					}}
					required
				/>
				<Input
					label={t("pages.auth.JoinPage.Contents.JoinForm.checkPw")}
					placeholder={t("pages.auth.JoinPage.Contents.JoinForm.checkPw")}
					name="rePw"
					type="password"
					autoComplete="new-password"
					validation={{
						validate: (value) =>
							value === currentPassword ||
							t("pages.auth.JoinPage.Contents.JoinForm.dontMatch"),
					}}
					required
				/>
				<div className="btn-wrap">
					<button
						className="btn__solid"
						color="gray"
						onClick={() => setCurrentStep("policy")}
					>
						{t("pages.auth.JoinPage.Contents.JoinForm.prev")}
					</button>
					<button
						className="btn__solid"
						color="primary"
						onClick={registerForm.handleSubmit(request)}
					>
						{t("pages.auth.JoinPage.Contents.JoinForm.next")}
					</button>
				</div>
			</Form>
			<p className="mail-resend">
				{t("pages.auth.JoinPage.Contents.JoinForm.alreadyMember")}
				<button type="button" className="btn-mail-resend" onClick={() => navigate("/")}>
					{t("pages.auth.JoinPage.Contents.JoinForm.login")}
				</button>
			</p>
			<AlertTemplate
				alertModalState={validateModal}
				setAlertModalToggle={setValidateModal}
				alertType={validateModalType}
			>
				<p className="alert-content">
					<div className="modal-text">{validateModalMsg}</div>
				</p>
				<div className="alert-footer">
					<button
						className="btn__solid"
						color={"primary"}
						onClick={() => {
							setValidateModal(false);
						}}
					>
						{t("pages.auth.JoinPage.Contents.JoinForm.confirm")}
					</button>
				</div>
			</AlertTemplate>
		</>
	);
};

export default JoinForm;
